import { Card, Typography, Grid, Box } from '@mui/material'

export default function UserCollapse({ user }: any) {
	return <Card>
		<Grid container direction={'column'}>
			<Box pl={3} m={2} bgcolor={'#F4F6F8'} borderRadius={2} height={50}>
				<Grid container direction={'row'} mt={1.5}>
					<Grid item xs={7} alignItems={'center'}>
						<Typography color={'#637381'} fontWeight={'bold'} textAlign='start'>
							Informações do cliente
						</Typography>
					</Grid>
					<Grid item xs={5} alignItems={'flex-start'}>
						<Typography color={'#637381'} fontWeight={'bold'} textAlign='start'>
							Dados
						</Typography>
					</Grid>
				</Grid>
			</Box>
			<Box m={2} mb={6}>
				<Grid container direction={'row'} ml={-1} spacing={4}>
					<Grid item xs={7}>
						<Typography variant="body1">ID</Typography>
					</Grid>
					<Grid item xs={5}>
						<Typography>{user?.id ?? ''}</Typography>
					</Grid>
					<Grid item xs={7}>
						<Typography>Nome</Typography>
					</Grid>
					<Grid item xs={5}>
						<Typography>{user?.name || "-"}</Typography>
					</Grid>
					<Grid item xs={7}>
						<Typography>E-mail</Typography>
					</Grid>
					<Grid item xs={5}>
						<Typography>{user?.email || "-"}</Typography>
					</Grid>
					<Grid item xs={7}>
						<Typography>Telefone</Typography>
					</Grid>
					<Grid item xs={5}>
						<Typography>{user?.phone || "-"}</Typography>
					</Grid>
					<Grid item xs={7}>
						<Typography>CNPJ</Typography>
					</Grid>
					<Grid item xs={5}>
						<Typography>{user?.cnpj || "-"}</Typography>
					</Grid>
					<Grid item xs={7}>
						<Typography>Razão Social</Typography>
					</Grid>
					<Grid item xs={5}>
						<Typography>{user?.corporate || "-"}</Typography>
					</Grid>
				</Grid>	
			</Box>
		</Grid>
	</Card>
}